import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputNumber, InputMoney, InputSwitch, InputPicklist, InputFile, Layout } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './product-model';  //editable..
import ProductChecklist from './product-checklist.component';
import AmounttypeChecklist from '../amounttype/amounttype-checklist.component';
import ScheduleChecklist from '../schedule/schedule-checklist.component';
import AddressList from '../address/address-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ProductView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        <InputPicklist name='producttype' label='Product Type' value={this.state.datarow.producttype} caption={this.state.datarow.producttypeCaption} readOnly/> 
                        <Input name='unit' label='Unit' value={this.state.datarow.unit} readOnly/>
                        <InputNumber name='qty' label='Qty' value={this.state.datarow.qty} readOnly/>
                        <InputNumber name='qtymin' label='Qty Min' value={this.state.datarow.qtymin} readOnly/>
                        <InputNumber name='qtymax' label='Qty Max' value={this.state.datarow.qtymax} readOnly/>
                        <InputMoney name='pricebase' label='Price Base' value={this.state.datarow.pricebase} readOnly/>
                        <InputMoney name='margin' label='Margin' value={this.state.datarow.margin} readOnly/>
                        <InputPicklist name='amounttype' label='Addional Value List' value={this.state.datarow.amounttype} caption={this.state.datarow.amounttypeCaption} disableAutoClose>
                            <AmounttypeChecklist history={this.props.history} currentId={this.state.datarow.amounttype} readOnly disableBackButton/>
                        </InputPicklist>
                        <InputMoney name='totalamount' label='Total Addional Values' value={this.state.datarow.totalamount} readOnly/>
                        <InputMoney name='pricesale' label='Price Sale' value={this.state.datarow.pricesale} readOnly/>
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>
                        <InputPicklist name='product' label='Sub Product List' value='' caption={this.state.datarow.productCaption} readOnly={this.state.datarow.product? false: true} disableAutoClose>
                            <ProductChecklist history={this.props.history} currentId={this.state.datarow.product} readOnly disableBackButton/>
                        </InputPicklist>  
                        <InputPicklist name='journalgroup' label='Journal group' value={this.state.datarow.journalgroup} caption={this.state.datarow.journalgroupCaption} readOnly/>
                        {this.state.datarow.producttypeType==='events' &&
                        <>
                        <InputPicklist name='event' label='Event' value={this.state.datarow.event} caption={this.state.datarow.eventCaption} readOnly/>
                        <InputPicklist name='schedule' label='Schedule List' value='' caption={this.state.datarow.scheduleCaption} readOnly={this.state.datarow.schedule? false: true} disableAutoClose>
                            <ScheduleChecklist history={this.props.history} currentId={this.state.datarow.schedule} readOnly disableBackButton/>
                        </InputPicklist>  
                        </>
                        }
                    </>
                    },
                    {caption: 'Links', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <AddressList history={this.props.history} root={this.props.root} caption='Link' parentType='product' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },
                ]}
                />
            </BaseView>
        );
    }
}